export class UpdateOrganizationName {
	public name: string;
}
